"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDecimalMultiplier = exports.parseBigintIsh = void 0;
const bn_js_1 = __importDefault(require("bn.js"));
const jsbi_1 = __importDefault(require("jsbi"));
const constants_1 = require("./constants");
function parseBigintIsh(bigintIsh) {
    return bigintIsh instanceof jsbi_1.default
        ? bigintIsh
        : typeof bigintIsh === "bigint" || bn_js_1.default.isBN(bigintIsh)
            ? jsbi_1.default.BigInt(bigintIsh.toString())
            : jsbi_1.default.BigInt(bigintIsh);
}
exports.parseBigintIsh = parseBigintIsh;
/**
 * Creates the multipler for an amount of decimals.
 * @param decimals
 * @returns
 */
const makeDecimalMultiplier = (decimals) => {
    return jsbi_1.default.exponentiate(constants_1.TEN, jsbi_1.default.BigInt(decimals));
};
exports.makeDecimalMultiplier = makeDecimalMultiplier;
//# sourceMappingURL=utils.js.map